import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  listaAdministradoras: [],
  administradoraPesquisa: {
    nome: undefined,
    pagina: 0
  },
  labelQuantidade: '',
  administradoraSelecionada: {
    id: 0,
    nome: '',
    endereco: '',
    numeroEndereco: '',
    complemento: '',
    cep: '',
    estado: undefined,
    cidade: '',
    bairro: '',
    telefone: '',
    celular: '',
    email: '',
    condominios: []
  },
  listaCondominios: []
}

const mutations = {
  atualizarListaAdministradoras(state, payload) {
    if(state.administradoraPesquisa.pagina === 0) {
      state.listaAdministradoras = payload.lista;
    } else {
      state.listaAdministradoras.push(...payload.lista);
    }

    state.labelQuantidade = payload.quantidade + (payload.quantidade == 1 ? " administradora encontrada" : " administradoras encontradas");
  },
  limparAdministradorasListadas(state) {
    state.listaAdministradoras = [];
  },
  limparAdministradoraPesquisa(state) {
    state.administradoraPesquisa = {
      nome: undefined,
      pagina: 0
    };
  },
  atualizarAdministradoraSelecionada(state, payload) {
    state.administradoraSelecionada = payload;
  },
  novaAdministradora(state) {
    state.administradoraSelecionada = {
      id: 0,
      nome: '',
      endereco: '',
      numeroEndereco: '',
      complemento: '',
      cep: '',
      estado: undefined,
      cidade: '',
      bairro: '',
      telefone: '',
      celular: '',
      email: '',
      condominios: []
    }
  },
  atualizarListaCondominios(state, payload) {
    state.listaCondominios = payload;
  },
  adicionarCondominio(state, condominio) {
    state.administradoraSelecionada.condominios.push(condominio);
  },
  removerCondominio(state, condominio) {
    let condominios = state.administradoraSelecionada.condominios;

    for(let i = 0; i < condominios.length; i++) {
      let atual = condominios[i];
      if(atual.id === condominio.id) {
        state.administradoraSelecionada.condominios.splice(i, 1);
        break;
      }
    }
  }
}

const actions = {
  listarAdministradoras(context, payload) {
    return axios.post(URLS.ADMINISTRADORAS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaAdministradoras', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('listarAdministradoras', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  limparAdministradorasListadas(context) {
    context.commit('limparAdministradorasListadas');
  },
  limparAdministradoraPesquisa(context){
    context.commit('limparAdministradoraPesquisa');
  },
  recuperarAdministradora(context, payload) {
    return axios.post(URLS.ADMINISTRADORAS_RECUPERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarAdministradoraSelecionada', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('recuperarAdministradora', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  novaAdministradora(context) {
    context.commit('novaAdministradora');
  },
  gravarAdministradora(context, payload) {
    return axios.post(URLS.ADMINISTRADORAS_GRAVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarAdministradoraSelecionada', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('gravarAdministradora', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  removerAdministradora(context, payload) {
    return axios.post(URLS.ADMINISTRADORAS_REMOVER, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('novaAdministradora');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('removerAdministradora', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  listarCondominios(context) {
    return axios.post(URLS.CONDOMINIOS_LISTAR, {})
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaCondominios', response.data.lista);
            break;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  context.dispatch('listarCondominios');
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  adicionarCondominio(context, payload) {
    return axios.post(URLS.ADMINISTRADORAS_ADICIONAR_CONDOMINIO, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('adicionarCondominio', payload);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('adicionarCondominio', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  removerCondominio(context, payload) {
    return axios.post(URLS.ADMINISTRADORAS_REMOVER_CONDOMINIO, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('removerCondominio', payload);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('removerCondominio', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  }
}

export default {
  state,
  mutations,
  actions
}